<div class="po-component-container calc-width">
  <!-- Filter Bar -->
  <div class="filter-bar">
    <div class="order-count">
      <span class="order-count-label">Ongoing Orders</span>
      <span class="order-count-badge">{{ items.length }}</span>
      <span class="order-count-total">LKR {{ totalValue | number }}</span>
    </div>

    @if (!isMobileScreen()) {
      <div class="filter-controls">
        <input #searchLive nz-input placeholder="Order ID" [(ngModel)]="searchValue"
          (input)="liveSearch()" class="filter-search">
        <nz-select [(ngModel)]="orderType" nzAllowClear nzPlaceHolder="Order Type"
          (ngModelChange)="onSelectOrderType(orderType)" class="filter-select">
          @for (data of orderTypeKeyValue; track data) {
            <nz-option [nzValue]="data.key" [nzLabel]="data.value"></nz-option>
          }
        </nz-select>
        <nz-select [(ngModel)]="selectedTables" nzMode="multiple" nzAllowClear nzPlaceHolder="Table"
          [nzMaxTagCount]="1" [nzMaxTagPlaceholder]="tagPlaceHolder"
          (ngModelChange)="onSelectTableMulti($event)" class="filter-select-wide">
          @for (data of tableNameKeyValue; track data) {
            <nz-option [nzValue]="data.key" [nzLabel]="data.value"></nz-option>
          }
        </nz-select>
        <ng-template #tagPlaceHolder let-selectedList>+{{ selectedList.length }}</ng-template>
        <nz-select [(ngModel)]="selectedSections" nzMode="multiple" nzAllowClear nzPlaceHolder="Section"
          [nzMaxTagCount]="1" [nzMaxTagPlaceholder]="tagPlaceHolder"
          (ngModelChange)="onSelectSection($event)" class="filter-select-wide">
          @for (data of sectionNameKeyValue; track data) {
            <nz-option [nzValue]="data.key" [nzLabel]="data.value"></nz-option>
          }
        </nz-select>
        <nz-select [(ngModel)]="userName" nzAllowClear nzPlaceHolder="Created User"
          (ngModelChange)="onSelectUser(userName)" class="filter-select">
          @for (data of userNameKeyValue; track data) {
            <nz-option [nzValue]="data.key" [nzLabel]="data.value"></nz-option>
          }
        </nz-select>
        <nz-select [(ngModel)]="status" nzAllowClear nzPlaceHolder="Order Status"
          (ngModelChange)="onSelectStatus(status)" class="filter-select">
          @for (data of orderStatusKeyValue; track data) {
            <nz-option [nzValue]="data.key" [nzLabel]="data.value"></nz-option>
          }
        </nz-select>
      </div>
    } @else {
      <a (click)="onFilterOrder()" class="filter-icon-btn">
        <em class="las la-filter"></em>
      </a>
    }
  </div>

<div class="orders-grid mt-3">
  @for (item of items; track item) {
    <div class="order-card">
      <!-- Order Header -->
      <div class="order-header" [class.cursor]="!isPaidCounterOrder(item)"
        (click)="!isPaidCounterOrder(item) && onFullView(item.orderId)">
        <div class="header-top">
          <div class="table-badge" nz-tooltip [nzTooltipTitle]="titleTemplate">
            {{ tableName(item.tables) | truncate: 15 }}
          </div>
          <ng-template #titleTemplate>
            @for (table of item.tables; track table; let i = $index) {
              <div>
                {{ table | tableName : tables }}
                @if (i !== item.tables.length - 1) { <span>,</span> }
              </div>
            }
          </ng-template>
          <div class="order-type-badge">
            {{ orderTypes[item.orderType] | capitalize }}
          </div>
          @if (item.referenceType) {
            <nz-tag [nzColor]="getReferenceTypeColor(item.referenceType)">
              {{ getReferenceTypeLabel(item.referenceType) }}
            </nz-tag>
          }
        </div>
        <div class="header-main">
          <h4 class="order-number">{{ item.orderNumber }}</h4>
          <span class="order-total">LKR {{ item.totalPrice | number }}</span>
        </div>
        <div class="header-meta">
          <span [nz-tooltip]="item.sectionName">{{ item.sectionName | truncate: 20 }}</span>
          <span>{{ item.createdAt | date : "dd/MM HH:mm" }}</span>
        </div>
        <div class="header-meta">
          <span class="created-by">
            {{ item.createdByName }}
          </span>
          <span class="status-text">
            {{ orderStatus[item.orderingStatus] | capitalize }}
            <!-- Payment is a separate track: a counter order is Paid while still being made. -->
            @if (item.paymentStatus === paymentStatus.Paid) {
              <nz-tag nzColor="success">Paid</nz-tag>
            } @else if (item.paymentStatus === paymentStatus.Partial) {
              <nz-tag nzColor="warning">Partial</nz-tag>
            }
          </span>
        </div>
      </div>

      <!-- Order Actions -->
      <div class="order-actions">
        @if (!isPaidCounterOrder(item)) {
          <button class="action-btn" (click)="onFullView(item.orderId)" nz-tooltip="View">
            <em class="las la-eye"></em>
          </button>
        }
        @if (canSplit(item)) {
          <button class="action-btn" (click)="onSplitBill(item)" nz-tooltip="Split">
            <em class="las la-columns"></em>
          </button>
        }
        <button class="action-btn" (click)="onUpdateOrderStatus(item)" nz-tooltip="Update All Items Status">
          <em class="las la-sync"></em>
        </button>
        <button class="action-btn" (click)="onKotPrint(item)" nz-tooltip="KOT Print">
          <em class="las la-print"></em>
        </button>
        @if (!isPaidCounterOrder(item)) {
          <button class="action-btn action-btn-success" (click)="onCheckout(item)" nz-tooltip="Checkout">
            <em class="las la-check-square"></em>
          </button>
          <button class="action-btn action-btn-danger" (click)="onDelete(item)" nz-tooltip="Delete">
            <em class="las la-trash"></em>
          </button>
        }
      </div>

      <!-- Food Items -->
      <div class="order-body">
        @for (foodItem of item.notSplitOrderDetails; track foodItem) {
          <div class="food-item-row">
            <div class="food-item-top">
              <div class="food-item-left">
                @if (canSplit(item)) {
                  <label nz-checkbox (nzCheckedChange)="onItemChecked(item.orderId, foodItem.id, $event)"
                    [nzChecked]="itemChecked(item.orderId, foodItem.id)"></label>
                }
                <span class="food-name">{{ foodItem.foodId | foodItemName : foodItems }}</span>
                <span class="food-qty">x{{ foodItem.quantity }}</span>
              </div>
              <div class="food-item-right">
                <span class="food-status-badge">{{ orderStatus[foodItem.cartStatus] | capitalize }}</span>
                @if (foodItem.cartStatus !== 4) {
                  <span class="food-time">{{ getElapsedTime(foodItem.createdAt) }}</span>
                }
              </div>
            </div>
            <div class="food-item-details">
              <small class="qty-tag">{{ foodItem.foodQuantityTagId! | quantityTagName: foodItemQuantity }}</small>
              @if (foodItem.extras && foodItem.extras.length > 0) {
                <small class="extras-text">
                  @for (data of foodItem.extras; track data; let i = $index) {
                    {{ data | extraFoodName: foodExtras }}@if (i !== foodItem.extras.length - 1) {, }
                  }
                </small>
              }
              @if (foodItem.kitchenIntroduction) {
                <small class="kitchen-note">{{ foodItem.kitchenIntroduction }}</small>
              }
            </div>
            <div class="food-item-actions">
              <button class="item-action-btn" nz-tooltip="Edit"
                (click)="onUpdateFood(foodItem, item.orderId, item.createdBy, item.tables)">
                <em class="las la-pen"></em>
              </button>
              @if (!isPaidCounterOrder(item)) {
                <button class="item-action-btn item-action-btn-danger" nz-tooltip="Delete"
                  (click)="onDeleteFood(foodItem)">
                  <em class="las la-trash"></em>
                </button>
              }
            </div>
          </div>
        }

        @if (item.splitOrderDetails.length > 0) {
          <a class="print-link" (click)="onPrintOrder(item, 'notSplit')">
            <em class="las la-print" nz-tooltip="Print Order"></em>
          </a>
        }

        @if (item.splitOrderDetails.length > 0) {
          <nz-divider nzText="Split" nzOrientation="left"></nz-divider>
          @for (foodItem of item.splitOrderDetails; track foodItem) {
            <div class="food-item-row">
              <div class="food-item-top">
                <div class="food-item-left">
                  @if (canSplit(item)) {
                    <label nz-checkbox (nzCheckedChange)="onItemChecked(item.orderId, foodItem.id, $event)"
                      [nzChecked]="itemChecked(item.orderId, foodItem.id)"></label>
                  }
                  <span class="food-name">{{ foodItem.foodId | foodItemName : foodItems }}</span>
                  <span class="food-qty">x{{ foodItem.quantity }}</span>
                </div>
                <div class="food-item-right">
                  <span class="food-status-badge">{{ orderStatus[foodItem.cartStatus] | capitalize }}</span>
                  @if (foodItem.cartStatus !== 4) {
                    <span class="food-time">{{ getElapsedTime(foodItem.createdAt) }}</span>
                  }
                </div>
              </div>
              <div class="food-item-details">
                @if (!isNameContainsSpecialCharacter(foodItem.foodId)) {
                  <small class="qty-tag">{{ foodItem.foodQuantityTagId! | quantityTagName: foodItemQuantity }}</small>
                }
                @if (foodItem.extras && foodItem.extras.length > 0) {
                  <small class="extras-text">
                    @for (data of foodItem.extras; track data; let i = $index) {
                      {{ data | extraFoodName: foodExtras }}@if (i !== foodItem.extras.length - 1) {, }
                    }
                  </small>
                }
                @if (foodItem.kitchenIntroduction) {
                  <small class="kitchen-note">{{ foodItem.kitchenIntroduction }}</small>
                }
              </div>
              <div class="food-item-actions">
                <button class="item-action-btn" nz-tooltip="Edit"
                  (click)="onUpdateFood(foodItem, item.orderId, item.createdBy, item.tables)">
                  <em class="las la-pen"></em>
                </button>
                @if (!isPaidCounterOrder(item)) {
                  <button class="item-action-btn item-action-btn-danger" nz-tooltip="Delete"
                    (click)="onDeleteFood(foodItem)">
                    <em class="las la-trash"></em>
                  </button>
                }
              </div>
            </div>
          }
          @if (item.splitOrderDetails.length > 0) {
            <a class="print-link" (click)="onPrintOrder(item, 'split')">
              <em class="las la-print" nz-tooltip="Print Split Order"></em>
            </a>
          }
        }
      </div>
    </div>
  }
</div>
</div>


<nz-modal [(nzVisible)]="isVisible" nzTitle="Custom Modal Title" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
  <div *nzModalContent>
    <nz-form-control>
      <nz-select [(ngModel)]="selectedOrderType" nzPlaceHolder="Select order type">
        @for (orderT of orderTypeKeyValueF; track orderT) {
          <nz-option [nzValue]="orderT.key"
          [nzLabel]="orderT.value"></nz-option>
        }
      </nz-select>
    </nz-form-control>
  </div>
</nz-modal>
